export default {
  Masculino: 1,
  Feminino: 2
}
